import { cancelledUnpaid } from "."

const timetableReportStatusEnum = {
    notDone: 0,     // Не отчитались
    done: 5,        // Проведено
    rescheduled: 9, // Перенесено
    canceledStudent: 10,    // Отменено (ученик)
    canceledSeminarian: 11, // Отменено (педагог)
    paidCancellation: 12, // Платная отмена
    cancelledUnpaid: cancelledUnpaid
}

export default timetableReportStatusEnum